import React, { useState } from 'react';
import './AnimationGallery.css';

// Placeholder data for the gallery
const galleryData = [
  {
    id: 1,
    title: 'Neon City Cyberpunk',
    category: '3D',
    embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', // Placeholder URL
    thumbnail: 'https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=600&q=80',
  },
  {
    id: 2,
    title: 'Character Explainer',
    category: '2D',
    embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=600&q=80',
  },
  {
    id: 3,
    title: 'Product Commercial',
    category: '3D',
    embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?w=600&q=80',
  },
  {
    id: 4,
    title: 'Motion Graphics Promo',
    category: '2D',
    embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=600&q=80',
  },
  {
    id: 5,
    title: 'Abstract Fluid Sim',
    category: '3D',
    embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=600&q=80',
  },
  {
    id: 6,
    title: 'Brand Mascot Intro',
    category: '2D',
    embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1626544827763-d516dce335e2?w=600&q=80',
  }
];

function AnimationGallery() {
  const [filter, setFilter] = useState('All');
  const [activeVideo, setActiveVideo] = useState(null);

  const filteredData = filter === 'All' 
    ? galleryData 
    : galleryData.filter(item => item.category === filter);

  return (
    <div className="gallery-page">
      <header className="gallery-header">
        <h1>Animation Portfolio</h1>
        <p>Explore our recent 2D and 3D animation projects.</p>
        
        <div className="gallery-filters">
          <button 
            className={`filter-btn ${filter === 'All' ? 'active' : ''}`}
            onClick={() => setFilter('All')}
          >
            All Work
          </button>
          <button 
            className={`filter-btn ${filter === '2D' ? 'active' : ''}`}
            onClick={() => setFilter('2D')}
          >
            2D Animation
          </button>
          <button 
            className={`filter-btn ${filter === '3D' ? 'active' : ''}`}
            onClick={() => setFilter('3D')}
          >
            3D Animation
          </button>
        </div>
      </header>

      <div className="gallery-grid">
        {filteredData.map((item) => (
          <div 
            key={item.id} 
            className="gallery-item"
            onClick={() => setActiveVideo(item)}
          >
            <div className="thumbnail-container">
              <img src={item.thumbnail} alt={item.title} className="thumbnail-image" />
              <div className="play-overlay">
                <span className="play-icon">▶</span>
              </div>
            </div>
            <div className="item-info">
              <h3>{item.title}</h3>
              <span className="badge">{item.category}</span>
            </div>
          </div>
        ))}
      </div>

      {activeVideo && (
        <div className="video-modal-overlay" onClick={() => setActiveVideo(null)}>
          <div className="video-modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setActiveVideo(null)}>×</button>
            <div className="video-wrapper">
              <iframe 
                src={activeVideo.embedUrl} 
                title={activeVideo.title}
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
            <div className="modal-info">
              <h2>{activeVideo.title}</h2>
              <span className="badge">{activeVideo.category}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AnimationGallery;
